import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';
import { FaStar, FaRegStar, FaUser, FaClock, FaCheck } from 'react-icons/fa';
import './FeedbackModal.css';

const FeedbackModal = ({ show, handleClose, feedback, onMarkAsRead, users }) => {
    if (!feedback) return null;

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';

        let date;
        if (timestamp.toDate) {
            date = timestamp.toDate();
        }
        else if (timestamp instanceof Date) {
            date = timestamp;
        }
        else if (typeof timestamp === 'number') {
            date = new Date(timestamp);
        }
        else {
            return 'N/A';
        }

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const renderStars = (score) => {
        return Array(5).fill(0).map((_, index) => (
            index < score ? <FaStar key={index} className="feedback-modal-star-icon filled" /> : <FaRegStar key={index} className="feedback-modal-star-icon" />
        ));
    };

    const user = users.find(u => u.userId === feedback.userId);

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered style={{ direction: 'rtl' }}>
            <Modal.Header className="py-2" style={{ direction: 'rtl', justifyContent: 'space-between', flexDirection: 'row-reverse', alignItems: 'center' }}>
                <Button variant="dark" onClick={handleClose} className="p-0" style={{ width: '50px', height: '50px', marginRight: '0px', marginLeft: '0px' }}>
                    <span style={{ fontSize: '2rem' }}>×</span>
                </Button>
                <div className="d-flex align-items-center gap-3">
                    <h4 className="mb-0">פרטי משוב</h4>
                    <div className="feedback-modal-status-badge">
                        {feedback.wasRead ? (
                            <Badge bg="success" className="px-2 py-1">
                                <FaCheck className="me-1" />
                                נקרא
                            </Badge>
                        ) : (
                            <Badge bg="warning" text="dark" className="px-2 py-1">
                                לא נקרא
                            </Badge>
                        )}
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body className="p-3">
                <div className="feedback-modal-section">
                    {/* User Details Section */}
                    <section className="feedback-modal-user-details-section">
                        <div className="d-flex align-items-center mb-2">
                            <FaUser className="me-2" />
                            <h5 className="mb-0">פרטי משתמש</h5>
                        </div>
                        <div className="feedback-modal-user-info-grid">
                            <div className="feedback-modal-info-item">
                                <span className="feedback-modal-info-label">מזהה משתמש:</span>
                                <span className="feedback-modal-info-value">{feedback.userId}</span>
                            </div>
                            <div className="feedback-modal-info-item">
                                <span className="feedback-modal-info-label">שם:</span>
                                <span className="feedback-modal-info-value">{user?.userName || 'לא צוין'}</span>
                            </div>
                            <div className="feedback-modal-info-item">
                                <span className="feedback-modal-info-label">אימייל:</span>
                                <span className="feedback-modal-info-value">{user?.userEmailAddress || 'לא צוין'}</span>
                            </div>
                            <div className="feedback-modal-info-item">
                                <span className="feedback-modal-info-label">ציון:</span>
                                <div className="feedback-modal-stars-container">
                                    {renderStars(feedback.satisfactionScore)}
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Timestamp Section */}
                    <section className="feedback-modal-timestamp-section">
                        <div className="d-flex align-items-center mb-2">
                            <FaClock className="me-2" />
                            <h5 className="mb-0">תאריך וזמן</h5>
                        </div>
                        <div className="feedback-modal-timestamp-info">
                            <div className="feedback-modal-info-item">
                                <span className="feedback-modal-info-label">נשלח ב:</span>
                                <span className="feedback-modal-info-value">{formatDate(feedback.feedbackTimestamp)}</span>
                            </div>
                            {feedback.whenWasRead && (
                                <div className="feedback-modal-info-item">
                                    <span className="feedback-modal-info-label">נקרא ב:</span>
                                    <span className="feedback-modal-info-value">{formatDate(feedback.whenWasRead)}</span>
                                </div>
                            )}
                        </div>
                    </section>

                    {/* Feedback Content Section */}
                    <section className="feedback-modal-feedback-content-section">
                        <h5 className="mb-2">תוכן המשוב</h5>
                        <div className="feedback-modal-feedback-content">
                            <div className="feedback-modal-feedback-section">
                                <h6 className="mb-1">מה המשתמש אוהב:</h6>
                                <p>{feedback.whatUserLikes || 'לא צוין'}</p>
                            </div>
                            <div className="feedback-modal-feedback-section">
                                <h6 className="mb-1">מה אפשר לשפר:</h6>
                                <p>{feedback.whatToImprove || 'לא צוין'}</p>
                            </div>
                        </div>
                    </section>
                </div>
            </Modal.Body>
            <Modal.Footer className="py-2">
                <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                    <div className="feedback-modal-buttons-container">
                        {!feedback.wasRead && (
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => {
                                    onMarkAsRead(feedback.id);
                                    handleClose();
                                }}
                                className="me-2"
                            >
                                <FaCheck className="me-1" />
                                סמן כנקרא
                            </Button>
                        )}
                        <Button variant="secondary" size="sm" onClick={handleClose}>
                            סגור
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default FeedbackModal; 